var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { Select } from "../Select";
import { Input } from "../Input";
import { phoneInputCountries, translateSelectedValue } from "./utils/functions";
// styles
import "./phoneInput.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-phoneInput",
};
const PhoneInput = forwardRef((_a, ref) => {
    var { className, currentLanguage, label, onChangeCountry, selectedCountry } = _a, rest = __rest(_a, ["className", "currentLanguage", "label", "onChangeCountry", "selectedCountry"]);
    const classList = classNames("tecma-phoneInput", className);
    return (_jsxs("div", { className: classList, children: [_jsx(Select, { options: phoneInputCountries(currentLanguage), value: translateSelectedValue(selectedCountry, currentLanguage), onChange: onChangeCountry, closeMenuOnSelect: true, label: label }), _jsx(Input, Object.assign({ ref: ref, type: "number" }, rest))] }));
});
PhoneInput.defaultProps = defaultProps;
export default React.memo(PhoneInput);
